import { render } from "./AgentLandingBlockHowItWorks.vue?vue&type=template&id=37613a23&scoped=true&lang=pug"
import script from "./AgentLandingBlockHowItWorks.vue?vue&type=script&lang=js"
export * from "./AgentLandingBlockHowItWorks.vue?vue&type=script&lang=js"

import "./AgentLandingBlockHowItWorks.vue?vue&type=style&index=0&id=37613a23&lang=scss&scoped=true"

import exportComponent from "/Users/aladdin/Documents/Petar/fairwey-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37613a23"]])

export default __exports__